var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CFBaseBulletUtils } from '@connectrn/ds-ui-base';
import { CFIcon, CFText } from '../../components';
import { useCFTestID } from '../../hooks';
import { CFBulletElements } from './Bullet.styles';
export const CFBullet = (_a) => {
    var { color = 'default', icon, iconVariant, label, size = 'md' } = _a, rest = __rest(_a, ["color", "icon", "iconVariant", "label", "size"]);
    const { commonAttrs, elementTestIDString } = useCFTestID('cf-bullet', rest);
    const { Root } = CFBulletElements;
    const { getIconSize, getTypeScale, getTextColor } = CFBaseBulletUtils;
    return (React.createElement(Root, Object.assign({ "$color": color, "$size": size }, commonAttrs), icon ? (React.createElement(CFIcon, { color: getTextColor(color), icon: icon, size: getIconSize(size), testID: elementTestIDString('icon'), variant: iconVariant })) : (React.createElement(CFText, { align: 'center', color: getTextColor(color), scale: getTypeScale(size), testID: elementTestIDString('label') }, label))));
};
